<div class="modal fade" id="dietSetModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
	<div class="modal-dialog">
		<div class="modal-content">
			<div class="modal-header">
				<button type="button" class="btn-close" (click)="dialogClose()"></button>
			</div>
			<form>
				<div class="modal-body">
					<div class="container">
						<div class="mb-3">
							<div class="row g-2">
								<div class="form-floating col-md">
									<input
										type="date"
										class="form-control"
										name="dateFrom"
										id="dateFrom"
										[(ngModel)]="data.dateFrom"
										[readonly]="isItemBefore"
									/>
									<label for="dateFrom">Data od</label>
								</div>
								<div class="form-floating col-md">
									<input
										type="date"
										class="form-control"
										name="dateTo"
										id="dateTo"
										[(ngModel)]="data.dateTo"
										[readonly]="isItemAfter"
									/>
									<label for="dateTo">Data do</label>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="form-floating">
								<select class="form-control" name="kind" [(ngModel)]="data.kind">
									@for (item of cashOutKind; track item.id) {
										<option [value]="item.id">
											{{ item.name }}
										</option>
									}
								</select>
							</div>
						</div>
					</div>
				</div>
			</form>
			<div class="modal-footer">
				<div class="container">
					<div class="row">
						<div class="col-sm text-end">
							<div class="btn btn-primary me-2" (click)="submit()">Zapisz</div>
							<div class="btn btn-secondary" data-bs-dismiss="modal" (click)="dialogClose()">Anuluj</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<app-dynamic-table
	[tableRows]="tableRows"
	[elements]="diets"
	[haveAnyFilters]="false"
	[haveLink]="false"
	[haveButton]="true"
	(buttonClicked)="setDiet($event)"
>
</app-dynamic-table>
<div class="row">
	<div class="btn btn-primary" (click)="openModal()">
		<!--this button actually adds the diet to the database,
		but for business diets are one of the types of mobility package,
 		so only the name of the button had to be changed with the refactor-->
		Dodaj forme płatności pakietu mobilności
	</div>
</div>
